type StorageValue = string | number | boolean | object | null
type StorageType = 'local' | 'session'

class StorageHelper {
  private storage: Storage

  constructor(type: StorageType = 'session') {
    this.storage = type === 'local' ? localStorage : sessionStorage
  }

  // 设置数据
  set<T extends StorageValue>(key: string, value: T): void {
    try {
      const val = typeof value === 'string' ? value : JSON.stringify(value)
      this.storage.setItem(key, val)
    } catch (error) {
      console.error(`Storage.set error for key "${key}":`, error)
    }
  }

  // 获取数据
  get<T extends StorageValue>(key: string, defaultValue: T): T {
    try {
      const val = this.storage.getItem(key)
      if (val === null) return defaultValue
      return JSON.parse(val) as T
    } catch (error) {
      console.error(`Storage.get error for key "${key}":`, error)
      return defaultValue
    }
  }

  // 删除指定 key
  remove(key: string): void {
    this.storage.removeItem(key)
  }

  // 清空所有
  clear(): void {
    this.storage.clear()
  }
}

// 默认导出：两个实例
const sessionStore = new StorageHelper('session')
const localStore = new StorageHelper('local')

export { sessionStore, localStore }
